// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-SideBarLayout-module__scrollBar-EPDm8 {
  scrollbar-gutter: stable both-edges;
  background-color: var(--background-secondary);
  scrollbar-color: var(--border-primary) var(--background-secondary);
  background: var(--background-secondary);
  overscroll-behavior: contain;
}

.nightbot-SideBarLayout-module__main-PXuO0 {
  display: flex;
  flex-direction: column;
}

.nightbot-SideBarLayout-module__header-jeYeP,
.nightbot-SideBarLayout-module__navBar-Wpytt {
  border-color: var(--border-primary);
}

[data-mantine-color-scheme='light']:root .nightbot-SideBarLayout-module__header-jeYeP,[data-mantine-color-scheme='light']:root .nightbot-SideBarLayout-module__navBar-Wpytt {
    border-color: var(--border-secondary);
  }
`, "",{"version":3,"sources":["webpack://./src/components/layouts/SideBarLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,kEAAkE;EAClE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,mCAAmC;AACrC;;AAGE;IAEE,qCAAqC;EACvC","sourcesContent":[".scrollBar {\n  scrollbar-gutter: stable both-edges;\n  background-color: var(--background-secondary);\n  scrollbar-color: var(--border-primary) var(--background-secondary);\n  background: var(--background-secondary);\n  overscroll-behavior: contain;\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n}\n\n.header,\n.navBar {\n  border-color: var(--border-primary);\n}\n\n@mixin light-root {\n  .header,\n  .navBar {\n    border-color: var(--border-secondary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollBar": `nightbot-SideBarLayout-module__scrollBar-EPDm8`,
	"main": `nightbot-SideBarLayout-module__main-PXuO0`,
	"header": `nightbot-SideBarLayout-module__header-jeYeP`,
	"navBar": `nightbot-SideBarLayout-module__navBar-Wpytt`
};
export default ___CSS_LOADER_EXPORT___;
